import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { Body2, Caption1, CompleteCheckbox, SpinnerLoader, Tooltip } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import { getPersonalizedDateFormat } from "~/store/selectors/selector.configOptions.jsx";
import { formatDateRange, formatDateSmart } from "~/utils/date.jsx";
import AvatarContainer from "../Users/AvatarContainer.jsx";
import UserNameComponent from "../Users/UserNameComponent.jsx";

const CompletedSubtaskList = ({
  id,
  name,
  completed,
  assigneeId,
  pending,
  canModify,
  onOpenSubtask,
  isTaskCompleted,
  dueOn,
}) => {
  const handleOpenSubtask = useCallback(() => {
    !isTaskCompleted && canModify && onOpenSubtask(id);
  }, [canModify, id, isTaskCompleted, onOpenSubtask]);

  const format = useSelector(getPersonalizedDateFormat);
  const formattedDate = formatDateRange(dueOn, dueOn, format);
  const fullDueDate = formatDateSmart(dueOn, format, true);

  return (
    <div className="task subtask subtask_item tw-opacity-50 completed_subtask">
      <div
        className={classnames("task_view_mode tw-flex tw-flex-row", {
          pending,
        })}
      >
        {!pending ? (
          <CompleteCheckbox
            disabled={isTaskCompleted}
            onClick={handleOpenSubtask}
            className="tw-shrink-0 tw-mr-2"
            completed
          />
        ) : null}
        {pending ? <SpinnerLoader className="tw-h-6 tw-w-6 tw-mr-2 tw-shrink-0 tw-self-start" /> : null}
        <span
          className={classnames("task_name tw-flex-1 tw-mt-0.5", {
            "tw-line-through": completed,
          })}
        >
          <Body2>{name}</Body2>
        </span>
        {dueOn ? (
          <Tooltip title={fullDueDate}>
            <Caption1
              lineHeight="loose"
              className="tw-px-2 tw-h-6 tw-pt-[1px] tw-font-bold"
            >
              {formattedDate}
            </Caption1>
          </Tooltip>
        ) : null}

        {assigneeId > 0 ? (
          <Tooltip title={<UserNameComponent id={assigneeId} />}>
            <div className="tw-w-6 tw-ml-1">
              <AvatarContainer id={assigneeId} />
            </div>
          </Tooltip>
        ) : dueOn ? (
          <div className="tw-w-6 tw-ml-1"></div>
        ) : null}
      </div>
    </div>
  );
};

CompletedSubtaskList.propTypes = {
  id: PropTypes.number.isRequired,
  isTaskCompleted: PropTypes.bool,
  name: PropTypes.string.isRequired,
  completed: PropTypes.bool,
  canModify: PropTypes.bool,
  pending: PropTypes.bool,
  onOpenSubtask: PropTypes.func,
  assigneeId: PropTypes.number,
  dueOn: PropTypes.number,
};

CompletedSubtaskList.defaultProps = {
  completed: true,
  pending: false,
  canModify: false,
  onOpenSubtask: () => null,
  isTaskCompleted: false,
  assigneeId: 0,
};

CompletedSubtaskList.displayName = "CompletedSubtaskList";

export default CompletedSubtaskList;
